import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import DashboardPage from "./pages/DashboardPage";
import SessionPage from "./pages/SessionPage";
import JoinFamilyPage from "./pages/JoinFamilyPage";
import PlansPage from "./pages/PlansPage";
import SessionResultsPage from "./pages/SessionResultsPage";
import PublicResultsPage from "./pages/PublicResultsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import SmsPolicyPage from "./pages/SmsPolicyPage";
import ProtectedRoute from "./components/ProtectedRoute";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/families/:familyId/plans"
        element={
          <ProtectedRoute>
            <PlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/:sessionId"
        element={
          <ProtectedRoute>
            <SessionResultsPage />
          </ProtectedRoute>
        }
      />

      {/* Public, read-only poll-style results. */}
      <Route path="/r/:token" element={<PublicResultsPage />} />
      {/* Public magic-link page — members reach this from their SMS link. */}
      <Route path="/s/:token" element={<SessionPage />} />
      {/* Public "join the family" page — invitees reach this from their invite link. */}
      <Route path="/join/:token" element={<JoinFamilyPage />} />

      {/* Public legal pages (also linked from Twilio messaging consent). */}
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/sms-policy" element={<SmsPolicyPage />} />
    </Routes>
  );
};

export default AppRoutes;
